// extracted by mini-css-extract-plugin
export default {"mCard":"LB-z","image":"MB-z","imageNoBackground":"NB-z","imageHasCategory":"OB-z","fullWidth":"PB-z"};